import React, { useState, useRef, useEffect, SetStateAction } from "react";
import { getLogonInfoFromCookies } from "../utils/util";
import { Box, Tooltip } from "@vapor/v3-components";
import {
  faGear,
  faPlusCircle,
  faUser,
  faGrid,
} from "@fortawesome/pro-regular-svg-icons";
import {
  VaporThemeProvider,
  VaporPage,
  VaporIcon,
  Title,
  ExtendedAvatar,
  Card,
  CardMedia,
  Grid,
  Spinner,
  NotificationOverflow,
  AlertTitle,
  VaporAppBar,
  Typography,
  IconButton,
  VaporUIShellNav,
  Menu,
  MenuItem,
} from "@vapor/v3-components";
import { getFilterList } from "../services/filterListService";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { RootState } from "../store/store";
import { usePersistentState } from "../store/usePersistentState";
import { useWindowWidth } from "../utils/useWindowWidth";
import { ResponsiveCard } from "../components/ResponsiveCard";
import { FilterListResponse } from "../services/Models/FilterListModel";
import { SiteParametersResponse } from "../services/Models/SiteParametersModel";
import { CmsFilterDescriptorBase } from "../services/Models/FilterDescriptorModel";
import { AuthResponse } from "../services/Models/AuthModel";
import { bgcolor, color } from "@mui/system";
import { ToolbarButtons } from "../components/ToolbarButtons";
import { getSiteParameters } from "../services/siteParametersService";
import { useAuth } from "../Router/AuthProvider";
import { returnError } from "../utils/util";

export interface localFilter {
  filterId: number;
  filterName: string;
  IconFile: string;
  TotPub: number;
  LinkedDocs: boolean;
  noDownloadVideo: boolean;
  idObject?: number;
}

const Home: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { performLogout } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [filters, setFilters] = useState<localFilter[]>(() => {
    const filterList = JSON.parse(
      localStorage.getItem("filterList") ?? "null"
    ) as localFilter[];
    if (filterList) {
      return filterList;
    } else return [];
  });
  const getUserNameValue = (): string => {
    const loginResult = getLogonInfoFromCookies();
    if (loginResult) {
      return loginResult.UserLogin ?? "";
    } else return "";
  };
  const userName = useRef(getUserNameValue());
  // const image = useSelector((state: RootState) => {
  //   return state.user.image;
  // });
  const [image, setImage] = usePersistentState("image", "");

  const windowWidth = useWindowWidth(); // Larghezza della finestra

  const cardWidth = Math.max((windowWidth - 170) / 4, 150); // Larghezza minima 50px
  const isSingleRow = cardWidth < 210; // Una sola card per riga se la larghezza è troppo piccola

  const localSiteParameters = useRef<SiteParametersResponse>(
    JSON.parse(localStorage.getItem("SiteParameters") ?? "{}")
  );

  // const [anchorEl, setAnchorEl] = React.useState(null);
  // const open = Boolean(anchorEl);
  // const handleClick = (event: any) => {
  //   setAnchorEl(event.currentTarget);
  // };
  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  const callFilter = (filterId: number) => {
    // if (filterId === 2735) navigate("/test");
    //else
    navigate(`/filter/${filterId}`);
  };

  const loadFilters = async (loginResult: AuthResponse, reload?: boolean) => {
    if (filters.length === 0 || reload) {
      setLoading(true);
      try {
        if (reload) {
          const resultSite: SiteParametersResponse = await getSiteParameters(
            null
          );
          if (resultSite && resultSite.ResultCode !== "ERROR") {
            localSiteParameters.current = resultSite;
            if (localSiteParameters.current.Visualizzazione === "continuo") {
              navigate("/presentationPage");
            }
          } else {
            setError("LoadSiteParameters : " + t("errore interno"));
            console.error("LoadSiteParameters Error :", "no result");
            setLoading(false);
            return;
          }
        }
        const result: FilterListResponse = await getFilterList(
          loginResult.SecurityToken,
          loginResult.Language ?? "it",
          localSiteParameters.current.ContPubFiltro
        );
        if (result && result.ResultCode !== "ERROR") {
          console.log("getFilter successful:");
          const locFilters: localFilter[] = result.Filters.map(
            (filter: CmsFilterDescriptorBase) => {
              const appFilter: localFilter = {
                filterId: filter.FilterId,
                filterName: filter.FilterName,
                IconFile: filter.IconFile,
                TotPub: filter.TotPub,
                LinkedDocs: filter.LinkedDocs === "1" ? true : false,
                noDownloadVideo:
                  filter.DownloadVideo === "nodownload" ? true : false,
              };
              return appFilter;
            }
          );

          localStorage.setItem("filterList", JSON.stringify(locFilters));
          setFilters(locFilters);
          if (localSiteParameters.current.Visualizzazione === "tabs") {
            navigate(`/filter/${locFilters[0].filterId}`);
          }
        } else {
          setError(t(returnError(result)));
          console.error("loadFilters Error :", "no result");
        }
      } catch (error) {
        setError(t("errore interno"));
        console.error("loadFilters Error :", error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    const loginResult = getLogonInfoFromCookies();
    if (!loginResult)
      //navigate("/logout");
      performLogout();
    if (loginResult && loginResult.SecurityToken && !loading) {
      loadFilters(loginResult);
    }
  }, []);

  const onReloadFilters = async () => {
    const loginResult = getLogonInfoFromCookies();
    if (!loginResult)
      //navigate("/logout");
      performLogout();
    if (loginResult && loginResult.SecurityToken && !loading) {
      await loadFilters(loginResult, true);
    }
  };

  const homePage = () => {
    return (
      <VaporPage sx={{ bgcolor: "strateLayer2" }}>
        {/* <VaporPage> */}
        <Title divider title={t("filters-list")} size="small" />
        {/* <Grid container spacing={2} justifyContent="left" margin={2}> */}
        <Grid
          container
          spacing={2}
          justifyContent="flex-start"
          marginTop={1}
          marginLeft={2}
          marginRight={2}
          width={windowWidth - 90}
        >
          {filters.map((card, index) => (
            <Grid item xs={isSingleRow ? 12 : 3} key={index}>
              <ResponsiveCard
                content={card.filterName}
                image={
                  window.config.BASE_URL + "/icon_archive/" + card.IconFile
                }
                numDoc={card.TotPub}
                width={isSingleRow ? windowWidth - 100 : cardWidth}
                onClick={() => callFilter(card.filterId)}
              />
            </Grid>
          ))}
        </Grid>
        {loading && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(255, 255, 255, 0.8)", // Sfondo semitrasparente opzionale
            }}
          >
            <Spinner size={64} />
          </Box>
        )}
        {error && (
          <NotificationOverflow severity="error" onClose={() => setError(null)}>
            <AlertTitle>{t("error-header")}</AlertTitle>
            {error}
          </NotificationOverflow>
        )}
      </VaporPage>
    );
  };
  return (
    <VaporThemeProvider>
      {localSiteParameters.current.Banner !== "0" ? (
        <VaporUIShellNav
          hideDrawer
          setDrawerOpen={() => {}}
          renderToolbar={
            <VaporAppBar
              disableDrawer
              leftContent={
                <Card>
                  <CardMedia
                    alt="image"
                    component="img"
                    image={window.config.BASE_URL + window.config.LOGO_CMS}
                    style={{
                      maxWidth: "200px",
                      maxHeight: "45px",
                      objectFit: "contain",
                    }}
                  />
                </Card>
              }
              rightContent={
                <ToolbarButtons
                  showReload={true}
                  onReloadFilters={onReloadFilters}
                />
              }
            />
          }
        >
          {homePage()}
        </VaporUIShellNav>
      ) : (
        <>{homePage()}</>
      )}
    </VaporThemeProvider>
  );
};

export default Home;
